export default "__VITE_ASSET__CIxQXPV___"